<template>
  <div class="d-flex align-items-center">
    <b-button
      class="btn__icon btn__icon--primary  px-2"
      qa="registry-wizard-previous-button"
      @click="goToPreviousElement"
    >
      <i
        class="far fa-chevron-left"
        aria-hidden="true"
      />
    </b-button>
    <b-button
      class="btn__icon btn__icon--primary  px-2"
      qa="registry-wizard-next-button"
      @click="goToNextElement"
    >
      <i
        class="far fa-chevron-right"
        aria-hidden="true"
      />
    </b-button>
  </div>
</template>

<script>
export default {
    name: 'WizardTreeArrowNavigation',
    props: {
        elementSelected: { type: Object },
        hierarchicalIndexesOfItemSelected: { type: Object },
        caseTree: { type: Object },
        entities: { type: Object }
    },
    methods: {
        goToPreviousElement() {
            if (this.elementSelected.type === this.entities.SAMPLE) {
                if (this.hierarchicalIndexesOfItemSelected.sampleIndex > 0) {
                    const previousSampleIndex = this.hierarchicalIndexesOfItemSelected.sampleIndex - 1
                    const previousSample = this.caseTree.samples[previousSampleIndex]
                    if (previousSample.portions.length) {
                        const previousPortionIndex = previousSample.portions.length - 1
                        const previousPortion = previousSample.portions[previousPortionIndex]
                        if (previousPortion.subportions.length) {
                            const previousSubportionIndex = previousSample.portions.length - 1
                            const previousSubportion = previousPortion.subportions[previousSubportionIndex]
                            this.$emit('selectElement', { element: previousSubportion,
                                hierarchicalIndexes: {
                                    sampleIndex: previousSampleIndex,
                                    portionIndex: previousPortionIndex,
                                    subportionIndex: previousSubportionIndex
                                } })
                            return
                        }
                        this.$emit('selectElement', { element: previousPortion,
                            hierarchicalIndexes: {
                                sampleIndex: previousSampleIndex,
                                portionIndex: previousPortionIndex
                            } })
                        return
                    }
                    this.$emit('selectElement', { element: previousSample,
                        hierarchicalIndexes: {
                            sampleIndex: previousSampleIndex
                        } })
                }
            } else if (this.elementSelected.type === this.entities.PORTION) {
                if (this.hierarchicalIndexesOfItemSelected.portionIndex > 0) {
                    const previousPortionIndex = this.hierarchicalIndexesOfItemSelected.portionIndex - 1
                    const previousPortion = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions[previousPortionIndex]
                    this.$emit('selectElement', { element: previousPortion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: previousPortionIndex
                        } })
                } else {
                    const previousSample = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex]
                    this.$emit('selectElement', { element: previousSample,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex
                        } })
                }
            } else if (this.elementSelected.type === this.entities.SUBPORTION) {
                if (this.hierarchicalIndexesOfItemSelected.subportionIndex > 0) {
                    const previousSubportionIndex = this.hierarchicalIndexesOfItemSelected.subportionIndex - 1
                    const previousSubportion =
                        this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions[this.hierarchicalIndexesOfItemSelected.portionIndex].subportions[previousSubportionIndex]
                    this.$emit('selectElement', { element: previousSubportion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: this.hierarchicalIndexesOfItemSelected.portionIndex,
                            subportionIndex: previousSubportionIndex
                        } })
                } else {
                    const previousPortion = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions[this.hierarchicalIndexesOfItemSelected.portionIndex]
                    this.$emit('selectElement', { element: previousPortion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: this.hierarchicalIndexesOfItemSelected.portionIndex
                        } })
                }
            }
        },
        goToNextElement() {
            const isNotLastSample = this.hierarchicalIndexesOfItemSelected.sampleIndex !== this.caseTree.samples.length - 1
            if (this.elementSelected.type === this.entities.SAMPLE) {
                if (this.elementSelected.portions.length) {
                    const nextPortion = this.elementSelected.portions[0]
                    this.$emit('selectElement', { element: nextPortion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: 0
                        } })
                } else if (isNotLastSample) {
                    const nextSampleIndex = this.hierarchicalIndexesOfItemSelected.sampleIndex + 1
                    const nextSample = this.caseTree.samples[nextSampleIndex]
                    this.$emit('selectElement', { element: nextSample,
                        hierarchicalIndexes: {
                            sampleIndex: nextSampleIndex
                        } })
                }
            } else if (this.elementSelected.type === this.entities.PORTION) {
                const portionsOfActualSample = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions
                const isNotLastPortion = this.hierarchicalIndexesOfItemSelected.portionIndex !== portionsOfActualSample.length - 1
                if (this.elementSelected.subportions.length) {
                    const nextSubportion = this.elementSelected.subportions[0]
                    this.$emit('selectElement', { element: nextSubportion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: this.hierarchicalIndexesOfItemSelected.portionIndex,
                            subportionIndex: 0
                        } })
                } else if (isNotLastPortion) {
                    const nextPortionIndex = this.hierarchicalIndexesOfItemSelected.portionIndex + 1
                    const nextPortion = portionsOfActualSample[nextPortionIndex]
                    this.$emit('selectElement', { element: nextPortion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: nextPortionIndex
                        } })
                } else if (isNotLastSample) {
                    const nextSampleIndex = this.hierarchicalIndexesOfItemSelected.sampleIndex + 1
                    const nextSample = this.caseTree.samples[nextSampleIndex]
                    this.$emit('selectElement', { element: nextSample,
                        hierarchicalIndexes: {
                            sampleIndex: nextSampleIndex
                        } })
                }
            } else if (this.elementSelected.type === this.entities.SUBPORTION) {
                const subportionsOfActualPortion = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions[this.hierarchicalIndexesOfItemSelected.portionIndex].subportions
                const isNotLastSubportion = this.hierarchicalIndexesOfItemSelected.subportionIndex !== subportionsOfActualPortion.length - 1
                const portionsOfActualSample = this.caseTree.samples[this.hierarchicalIndexesOfItemSelected.sampleIndex].portions
                const isNotLastPortion = this.hierarchicalIndexesOfItemSelected.portionIndex !== portionsOfActualSample.length - 1
                if (isNotLastSubportion) {
                    const nexSubportionIndex = this.hierarchicalIndexesOfItemSelected.subportionIndex + 1
                    const nextSubportion = subportionsOfActualPortion[nexSubportionIndex]
                    this.$emit('selectElement', { element: nextSubportion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: this.hierarchicalIndexesOfItemSelected.portionIndex,
                            subportionIndex: nexSubportionIndex
                        } })
                } else if (isNotLastPortion) {
                    const nextPortionIndex = this.hierarchicalIndexesOfItemSelected.portionIndex + 1
                    const nextPortion = portionsOfActualSample[nextPortionIndex]
                    this.$emit('selectElement', { element: nextPortion,
                        hierarchicalIndexes: {
                            sampleIndex: this.hierarchicalIndexesOfItemSelected.sampleIndex,
                            portionIndex: nextPortionIndex
                        } })
                } else if (isNotLastSample) {
                    const nextSampleIndex = this.hierarchicalIndexesOfItemSelected.sampleIndex + 1
                    const nextSample = this.caseTree.samples[nextSampleIndex]
                    this.$emit('selectElement', { element: nextSample,
                        hierarchicalIndexes: {
                            sampleIndex: nextSampleIndex
                        } })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
